import LoadingIndicator from "~/components/LoadingIndicator";
import loadable from "~/utils/loadable";

export default loadable(() => import("./Dashboard"), {
  fallback: <LoadingIndicator />
});
